export default __webpack_public_path__ + "img/adb054f755c8e4ca1fa4819372f0dd0f.png";